import './App.css';
import Home from './pages/home/home';

const App = ()=> {
  return (
    <div className="App">
      <Home/>
    </div>
  );
}

export default App;
